// global namespace and variable setup
"use strict";

/**
 * Test touch capabilities of user agent.
 *
 * @returns {Bool}
 */
const isTouch = function() {
  return ( ( 'ontouchstart' in window ) || // html5 browsers
    ( window.navigator.maxTouchPoints > 0 ) || // IE 11+
    ( window.navigator.msMaxTouchPoints > 0 ) ); // IE10
};

/**
 * Determine the operating system.
 *
 * @returns {String}
 */
const getOS = function() {
  let userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // Windows Phone must come first because its UA also contains "Android"
  if ( /windows phone/i.test( userAgent ) ) {
    return "windowsphone";
  }
  if ( /android/i.test( userAgent ) ) {
    return "android";
  }
  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if ( /iPad|iPhone|iPod/.test( userAgent ) && !window.MSStream ) {
    return "ios";
  }
  if ( /mac/i.test( userAgent ) ) {
    return "macos";
  }
  if ( /win/i.test( userAgent ) ) {
    return "windows";
  }
  return "unknown";
};

/**
 * Determine the user agent.
 *
 * @returns {String}
 */
const getUA = function() {
  let userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // MS Edge
  if ( /Edge/i.test( userAgent ) ) {
    return "edge";
  }

  // IE 11
  if ( '-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style ) {
    return "ie-11";
  }

  // IE <= 10
  if ( document.body.style.msTouchAction !== undefined ) {
    return "ie-legacy";
  }

  // Safari
  if ( navigator.vendor && navigator.vendor.indexOf( 'Apple' ) > -1 && navigator.userAgent && navigator.userAgent.indexOf( 'CriOS' ) == -1 && navigator.userAgent.indexOf( 'FxiOS' ) == -1 ) {
    return "safari";
  }

  return false;
};

/**
 * Return the global env vars
 *
 * @returns {Object}
 */
const getSettings = function() {

  var env = {
    path: {
      theme: ( window.wp_env.templateUrl !== undefined ) ? window.wp_env.templateUrl + '/' : '/'
    },
    isTouch: isTouch(),
    os: getOS(),
    ua: getUA(),
    breakpoints: {
      min: {
        s: 480,
        m: 768,
        l: 980,
        xl: 1200
      },
      max: {
        xs: 479,
        s: 767,
        m: 979,
        l: 1199
      }
    },
    speed: {
      fast: 100,
      normal: 300,
      slow: 500
    },
    promises: []
  };

  return {
    env: env
  };

};

export default getSettings;